import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config.service';
import { LocalAuthService } from '../auth/local-auth.service';
import { CustomerLogForStaff } from './types/partner';

@Injectable({
  providedIn: 'root'
})
export class ConsultingDashboardService {

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private authService: LocalAuthService
  ) { }

  getThisWeekConsultingActivitiesForStaff(staffId: number) {
    return this.http.get<CustomerLogForStaff[]>(`${this.config.dataApiUrl}/consulting/this-week-activities/${staffId}`);
  }
}
